<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
  <g clip-path="url(#add-selectie__a)">
    <path d="M24 18a6 6 0 1 1-12 0 6 6 0 0 1 12 0Zm-5.333-2.667a.667.667 0 0 0-1.334 0v2h-2a.667.667 0 0 0 0 1.334h2v2a.667.667 0 0 0 1.334 0v-2h2a.667.667 0 0 0 0-1.334h-2v-2ZM5.006 1.406a4.8 4.8 0 1 0 6.788 6.788 4.8 4.8 0 0 0-6.788-6.788Zm1.68 9.994C2.993 11.4 0 15.392 0 19.086c0 .615.499 1.114 1.114 1.114h9.192A8.005 8.005 0 0 1 10 18a7.98 7.98 0 0 1 2.654-5.952 5.44 5.44 0 0 0-2.54-.648H6.686Z"/>
    <path d="M13.226 8.366A4.198 4.198 0 0 0 20.4 5.4a4.198 4.198 0 0 0-6.686-3.386A5.96 5.96 0 0 1 14.4 4.8a5.97 5.97 0 0 1-1.174 3.566Z"/>
  </g>
  <defs>
    <clipPath id="add-selectie__a">
      <path d="M0 0h24v24H0z"/>
    </clipPath>
  </defs>
</svg>
